import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { LegendItem } from './deal-status-legent.types';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { AccountColor } from '@core/models';

@Component({
  selector: 'app-deal-status-legend',
  standalone: true,
  imports: [CommonModule, MatExpansionModule],
  templateUrl: './deal-status-legent.component.html',
  styleUrls: ['./deal-status-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealStatusLegendComponent implements OnInit {
  @Input() legendItems: LegendItem[] = [];

  accountColors: AccountColor[] = [];

  constructor(private store: Store) {}

  ngOnInit(): void {
    const account = this.store.selectSnapshot(AccountState.getAccount);
    this.accountColors = account?.colors ?? [];
  }

  getItemStyle(item: LegendItem): any {
    if (item.color.indexOf('account:') >= 0) {
      const colorId = parseInt(item.color.replace('account:', ''));
      const colorHex = this.accountColors.filter((item) => item.id === colorId)?.[0]?.hex_value;
      return {
        backgroundColor: colorHex,
      };
    }
    return {};
  }

  getItemClass(item: LegendItem): any {
    if (item.color.indexOf('account:') >= 0) {
      return '';
    }
    return `bg-${item.color}-500`;
  }
}
